import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import * as moment from 'moment';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { AlertService } from 'src/app/shared/index';

@Component({
  selector: 'app-report-filter',
  templateUrl: './solar-daily-report.component.html',
  styleUrls: ['./solar-daily-report.component.scss']
})
export class SolarDailyReportComponent implements OnInit, OnDestroy {
  siteId = '';
  startView = 'month';
  minView = 'day';
  date = new UntypedFormControl(new Date());
  reportType: string;
  navigationSubscription: any;
  max = new Date();
  constructor(
    public commonService: CommonService,
    private activeRoute: ActivatedRoute,
    private dataService: DataService,
    private _http: HttpClient,
    private alertService: AlertService,
    private router: Router
  ) {
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.siteId = localStorage.getItem('siteId');
        this.reportType = this.activeRoute.snapshot.paramMap.get('type');
      }
    });
  }
  ngOnInit() {}
  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }
  ok() {
    let url = '';
    if (this.date.value) {
      const selecteddate = moment(this.date.value).format('YYYY-MM-DD');

      switch (this.reportType) {
        case 'energy':
          url = this.commonService.getDailyEnergyReportUrl(
            this.siteId,
            selecteddate
          );
          break;
        case 'solar':
        default:
          url = this.commonService.getgenerateDailySolarReportUrl(
            this.siteId,
            selecteddate
          );
          break;
      }

      this.dataService.getPDF(url, true).subscribe((response) => {
        if (response.byteLength > 0) {
          const file = new Blob([response], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL, '_blank');
        } else {
          this.alertService.message = 'No data response !';
          this.alertService.showError(this.alertService.message);
        }
      });
    }
  }
}
